class PricingMatrix {
    constructor() {
        this.state = {
            optionSet: null,
            currentCharge: 0,
            quantity: 1,
            colors: 1
        };

        this.matrix = [
            { min: 24, max: 35, prices: [5.50, 7.50, 9.00, 10.50, 0, 0] },
            { min: 36, max: 49, prices: [4.75, 6.25, 7.75, 9.00, 10.25, 11.50] },
            { min: 50, max: 74, prices: [4.00, 5.25, 6.25, 7.25, 8.25, 9.25] },
            { min: 75, max: 99, prices: [3.25, 4.25, 5.00, 5.75, 6.75, 7.50] },
            { min: 100, max: 149, prices: [2.75, 3.50, 4.15, 4.85, 5.65, 6.35] },
            { min: 150, max: 199, prices: [2.35, 2.95, 3.50, 4.10, 4.75, 5.45] },
            { min: 200, max: 299, prices: [2.05, 2.55, 3.00, 3.50, 4.05, 4.65] },
            { min: 300, max: 499, prices: [1.85, 2.25, 2.65, 3.10, 3.55, 4.10] },
            { min: 500, max: 999, prices: [1.65, 1.95, 2.30, 2.70, 3.10, 3.60] },
            { min: 1000, max: 1299, prices: [1.40, 1.65, 1.95, 2.30, 2.65, 3.10] },
            { min: 1300, max: Infinity, prices: [1.20, 1.40, 1.70, 2.05, 2.40, 2.80] }
        ];

        this.init();
    }

    init() {
        window.addEventListener("load", () => {
            const polling = setInterval(() => {
                const optionSet = document.querySelector("div[id^='hulkapps_custom'] .hulkapps_option_set");
                const qtyInput = document.querySelector("input[name='quantity']");

                if (optionSet && qtyInput) {
                    clearInterval(polling);
                    this.state.optionSet = optionSet;
                    this.state.quantity = parseInt(qtyInput.value) || 1;
                    
                    setTimeout(() => this.main(qtyInput), 100);
                }
            }, 100);
            setTimeout(() => clearInterval(polling), 20000);
        });
    }

    main(qtyInput) {
        this.attachListeners(qtyInput);
        this.calculatePrice();
    }

    attachListeners(qtyInput) {
        this.state.optionSet.querySelectorAll(".hulk_number_of_colors input[type='radio']").forEach((radio, index) => {
            radio.addEventListener("change", () => {
                this.state.colors = index + 1;
                this.calculatePrice();
            });
            
            if(radio.checked) this.state.colors = index + 1;
        });

        qtyInput.addEventListener("change", (e) => {
            this.state.quantity = parseInt(e.target.value) || 0;
            this.calculatePrice();
        });
    }

    calculatePrice() {
        const qty = this.state.quantity;
        const colorIdx = this.state.colors - 1;
        
        const range = this.matrix.find(r => qty >= r.min && qty <= r.max);
        
        let unitPrice = 0;
        if (range && range.prices[colorIdx] !== 0) {
            unitPrice = range.prices[colorIdx];
        }

        this.state.currentCharge = unitPrice;
        this.updateUI();
    }

    updateUI() {
        const priceDisplay = document.getElementById("hulk-custom-price-total");
        const hiddenInput = this.state.optionSet.querySelector("input[type='hidden'][name='properties[Customization Price]']");

        if (priceDisplay) {
            priceDisplay.innerHTML = `Selection will add <span style="font-weight:900;">+$${this.state.currentCharge.toFixed(2)}</span> to the price`;
        }

        if (hiddenInput) {
            hiddenInput.value = `${this.state.colors} Color(s) | [$${this.state.currentCharge.toFixed(2)}]`;
        }

        if (this.state.currentCharge === 0) {
            priceDisplay.style.display = "none";
        } else {
            priceDisplay.style.display = "block";
        }
    }
}

new PricingMatrix();